<script lang="ts">
    import { isMobile } from "@app/services/isMobile";
    import FullScreenSearch from "./FullScreenSearch.svelte";
    if (isMobile()) {
        new FullScreenSearch({
            target: document.body,
        });
    }
</script>
